export default __webpack_public_path__ + "static/personality-collaborative-dark-e6513e23435955a33eb4f4c0ea0adb9a.png";